import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  container: {},
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  contentDivider: {
    margin: '50px 0 10px 0',
    height: 2,
  },
  helpContainer: {
    padding: theme.spacing(1),
    backgroundColor: grey[200],
  },
});
